import { FormBuilder, FormGroup } from '@angular/forms';
import {
  SectionAFormGroup,
  getSectionAFormGroup,
} from './+helpers/section-a-form.helper';
import {
  SectionBFormGroup,
  getSectionBFormGroup,
} from './+helpers/section-b-form.helper';
import {
  SectionCFormGroup,
  getSectionCFormGroup,
} from './+helpers/section-c-form.helper';
import {
  SectionDFormGroup,
  getSectionDFormGroup,
} from './+helpers/section-d-form.helper';
import {
  SectionEFormGroup,
  getSectionEFormGroup,
} from './+helpers/section-e-form.helper';
import {
  SectionFFormGroup,
  getSectionFFormGroup,
} from './+helpers/section-f-form.helper';
import {
  SectionGFormGroup,
  getSectionGFormGroup,
} from './+helpers/section-g-form.helper';
import {
  SectionHFormGroup,
  getSectionHFormGroup,
} from './+helpers/section-h-form.helper';
import {
  SectionIFormGroup,
  getSectionIFormGroup,
} from './+helpers/section-i-form.helper';
import {
  SectionJFormGroup,
  getSectionJFormGroup,
} from './+helpers/section-j-form.helper';

export interface ProjectWizardFormGroup {
  sectionAFormGroup: FormGroup<SectionAFormGroup>;
  sectionBFormGroup: FormGroup<SectionBFormGroup>;
  sectionCFormGroup: FormGroup<SectionCFormGroup>;
  sectionDFormGroup: FormGroup<SectionDFormGroup>;
  sectionEFormGroup: FormGroup<SectionEFormGroup>;
  sectionFFormGroup: FormGroup<SectionFFormGroup>;
  sectionGFormGroup: FormGroup<SectionGFormGroup>;
  sectionHFormGroup: FormGroup<SectionHFormGroup>;
  sectionIFormGroup: FormGroup<SectionIFormGroup>;
  sectionJFormGroup: FormGroup<SectionJFormGroup>;
}

export function getProjectWizardFormGroup(
  fb: FormBuilder
): FormGroup<ProjectWizardFormGroup> {
  return fb.nonNullable.group({
    sectionAFormGroup: getSectionAFormGroup(fb),
    sectionBFormGroup: getSectionBFormGroup(fb),
    sectionCFormGroup: getSectionCFormGroup(fb),
    sectionDFormGroup: getSectionDFormGroup(fb),
    sectionEFormGroup: getSectionEFormGroup(fb),
    sectionFFormGroup: getSectionFFormGroup(fb),
    sectionGFormGroup: getSectionGFormGroup(fb),
    sectionHFormGroup: getSectionHFormGroup(fb),
    sectionIFormGroup: getSectionIFormGroup(fb),
    sectionJFormGroup: getSectionJFormGroup(fb),
  });
}
